import React, { useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import { PagePaper } from "@/components/Paper/PagePaper";
import { PageTitle } from "@/components/Title";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { useParams } from "react-router-dom";
import { OrderDetailInfo } from "@/features/dmManagement/components/OrderDetailInfo";
import { AddressListDialog } from "@/features/dmManagement/components/AddressListDialog";
import { ReuploadDialog } from "@/features/dmManagement/components/ReuploadDialog";
import { useOrder } from "@/features/dmManagement/hooks/useOrder";
import { LinkButton } from "@/components/Button/LinkButton";
import { ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";

export const OrderDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { order, isLoading, mutate } = useOrder(
    id != null ? Number(id) : undefined
  );
  const [addressListOpen, setAddressListOpen] = useState(false);
  const [reuploadOpen, setReuploadOpen] = useState(false);

  return (
    <PagePaper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ContactMailIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>注文詳細</PageTitle>
        </Box>
        <LinkButton
          variant={ButtonVariantOption.Outlined}
          href="/dmManagement"
          wrapperSize={SizingWrapperStyle.INHERIT}
        >
          一覧に戻る
        </LinkButton>
      </Stack>
      {isLoading && <Typography>読み込み中...</Typography>}
      {!isLoading && !order && (
        <Typography>注文データが見つかりません</Typography>
      )}
      {order && (
        <>
          <OrderDetailInfo
            order={order}
            mutate={mutate}
            onOpenAddressList={() => {
              setAddressListOpen(true);
            }}
          />
          <AddressListDialog
            open={addressListOpen}
            onClose={() => {
              setAddressListOpen(false);
            }}
            orderId={order.id}
            addressListStatus={order.addressList.status}
            hasReport={order.addressList.hasReport}
            orderMutate={mutate}
            onReupload={() => {
              setAddressListOpen(false);
              setReuploadOpen(true);
            }}
          />
          <ReuploadDialog
            open={reuploadOpen}
            onClose={() => {
              setReuploadOpen(false);
            }}
            orderId={order.id}
            orderMutate={mutate}
          />
        </>
      )}
    </PagePaper>
  );
};
